import DebugLogger from './DebugLogger';

/**
 * SetTimeout wrapped inside a promise
 * @param {*} ms Time in milli seconds to wait before resolving the promise
 */
export const promiseTimeout = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Convert a human readable memory size (like 24GB or 5MB etc) to equivalant bytes
 * @param {String} sizeInString
 * @returns int
 */
export const readableToBytes = sizeInString => {
  const sizeWithoutSpaces = sizeInString.replace(' ', '');
  const denotation = sizeWithoutSpaces.slice(-2);
  const size = parseInt(sizeWithoutSpaces.slice(0, -2));
  switch (denotation) {
    case 'KB':
      return size * 1024;
    case 'MB':
      return size * 1024 * 1024;
    case 'GB':
      return size * 1024 * 1024 * 1024;
    case 'TB':
      return size * 1024 * 1024 * 1024 * 1024;
    default:
      return parseInt(sizeWithoutSpaces);
  }
};
/**
 * Exrcute an arbitraty javascript code, with the given context
 * !!! Important !!! This function does have security side effects
 * @param {String} script JavaScript code in string
 * @param {Object} context Context information for the script to work
 */
// eslint-disable-next-line
export const executeScript = async (script, context) => {
  // eslint-disable-next-line
  return new Function(...Object.keys(context), script)(...Object.values(context));
};

/**
 * Convert the format from the angular-datepicker module to flatpickr format.
 * @param format
 * @return {string}
 */
// eslint-disable-next-line
export const convertFormatToFlatpickr = format => {
  return (
    format
      // Remove the Z timezone offset, not supported by flatpickr.
      .replace(/Z/g, '')

      // Year conversion.
      .replace(/y/g, 'Y')
      .replace('YYYY', 'Y')
      .replace('YY', 'y')

      // Month conversion.
      .replace('MMMM', 'F')
      .replace(/M/g, 'n')
      .replace('nnn', 'M')
      .replace('nn', 'm')

      // Day in month.
      .replace(/d/g, 'j')
      .replace(/jj/g, 'd')

      // Day in week.
      .replace('EEEE', 'l')
      .replace('EEE', 'D')

      // Hours, minutes, seconds
      .replace('HH', 'H')
      .replace('hh', 'G')
      .replace('mm', 'i')
      .replace('ss', 'S')
      .replace(/a/g, 'K')
  );
};

export const getRandomString = length => {
  let result = '';
  // Unmistakable characters
  const characters = '23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz';
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

/**
 * Get a flat array of all input components in the form.
 * All the layout and button components will be removed
 * @param {Object} schema
 * @param {Boolean} onlyAMSFields
 */
export const getInputComponents = (schema, onlyAMSFields = false) => {
  const filterdComponents = [];
  const _filterComponents = _schema => {
    if (!_schema || !_schema.components) return;
    _schema.components.forEach(component => {
      if (component.type === 'fw-columns') {
        component.columns.forEach(colComponent => {
          _filterComponents(colComponent);
        });
      } else if (component.input === true && component.type !== 'fw-button') {
        if (!onlyAMSFields || component.amsField) filterdComponents.push(component);
      }
    });
  };
  _filterComponents(schema);
  return filterdComponents;
};

/**
 * Adds empty select option to the values (used for select component)
 * @param {Array} values
 */
export const addEmptySelectOption = values => {
  // only adds select if the item deoes not exists in the array
  if (values.findIndex(item => item.value === '') === -1) {
    values.unshift({
      value: '',
      label: 'Select'
    });
  }
  return values;
};

export const debug = new DebugLogger();
export { placeholders, get } from './placeholders';
